// src/services/ttn/devices.js
// AfriClimate device management

import { AFRICLIMATE_API as TTN, apiHeaders as ttnHeaders, handleResponse } from '../config';
import DEVICE_NAMES from './deviceNames';
import DEVICE_LOCATIONS from './deviceLocations';

// Runtime cache: admin-saved metadata overrides static fallbacks.
// Populated by deviceMetaService.applyMetaOverrides().
let _metaOverrides = {};
export const applyMetaOverrides = (overrides) => { _metaOverrides = overrides || {}; };

/** Map TTN device → app-standard shape */
export const mapDevice = (d) => {
  const id = d.deviceId || d._id;
  const shortId = id?.slice(-6) || id;
  const meta = _metaOverrides[id] || {};
  return {
    id,
    name:          meta.name     || DEVICE_NAMES[id]     || d.name || d.description || `Station ${shortId}`,
    location:      meta.location || DEVICE_LOCATIONS[id] || '',
    description:   d.description || '',
    status:        d.status === 'active' ? 'online' : (d.status || 'offline'),
    lat:           d.location?.latitude  ?? null,
    lng:           d.location?.longitude ?? null,
    altitude:      d.location?.altitude  ?? null,
    lastSeen:      d.lastSeen,
    tags:          d.tags || [],
    appId:         d.applicationId,
    devEui:        d.devEui,
    totalMessages: d.stats?.totalMessages ?? null,
  };
};

/** Get all AfriClimate devices (optionally filter by status: 'active'|'inactive'|'maintenance') */
export const fetchDevices = async (status = null) => {
  const url = status
    ? `${TTN.BASE_URL}/devices?status=${status}`
    : `${TTN.BASE_URL}/devices`;
  const json = await handleResponse(await fetch(url, { headers: ttnHeaders }));
  return (json.data || []).map(mapDevice);
};

/** Get a single AfriClimate device by ID or EUI */
export const fetchDevice = async (identifier) => {
  const json = await handleResponse(
    await fetch(`${TTN.BASE_URL}/devices/${identifier}`, { headers: ttnHeaders })
  );
  return mapDevice(json.data || json);
};

/** Update device metadata (name, description, tags, status) */
export const updateTTNDevice = async (identifier, updates) => {
  const json = await handleResponse(
    await fetch(`${TTN.BASE_URL}/devices/${identifier}`, {
      method: 'PATCH',
      headers: ttnHeaders,
      body: JSON.stringify(updates),
    })
  );
  return json.data || json;
};
